import { Footer } from '@/components/main/footer/Footer';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { Location, Outlet } from 'react-router-dom';
import { ROUTE_HELP_FEEDBACK } from '@/app/routes';
import { Theme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import HelpMenu from '@/components/help/HelpMenu';
import React, { FC, ReactElement } from 'react';

export const HelpPage: FC = (): ReactElement => {
  const location: Location = useLocation();

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} sx={{ minHeight: '100%' }}>
      {!isMobile && (
        <Grid item={true} marginBottom={'36px'}>
          <Typography variant={'h1'}>{'Помощь'}</Typography>
        </Grid>
      )}
      <Grid item={true} xs={true}>
        <Grid container={true} columnSpacing={isMobile ? 0 : 7}>
          {!isMobile && (
            <Grid item={true}>
              <HelpMenu />
            </Grid>
          )}
          <Grid item={true} xs={true}>
            <Outlet />
          </Grid>
        </Grid>
      </Grid>
      {isMobile && !location.pathname.includes(ROUTE_HELP_FEEDBACK) && (
        <Grid item={true} mt={5}>
          <Footer isMobile={isMobile} />
        </Grid>
      )}
    </Grid>
  );
};
